import React from 'react';

export default function PieChart(props) {
    const percentage = props.percentage||0;
    const degrees = (percentage / 100) * 360;
    const isMobile = window.innerWidth <= 1024; // Adjust the breakpoint as needed
    if(isMobile){
        return (
            <div className='h-[26px] w-[66px] text-[16px] font-bold bg-[#C3E9FF] flex justify-center items-center rounded-[12px]' style={{backgroundColor:'rgb(210,119,129)',border: '2px solid rgb(204,84,81)'}}>
                {props.text}
            </div>
        );
    }
    return (
        <div className='h-[46px] w-[80px] text-[22px] font-bold bg-[#C3E9FF] flex justify-center items-center rounded-[16px]' style={{backgroundColor:'rgb(210,119,129)',border: '2px solid rgb(204,84,81)'}}>
            {props.text}
            {/* <div className='h-[40px] w-[40px] rounded-[99px] bg-[white]' style={{ border: '2px solid #D9D9D9', position: 'relative', overflow: 'hidden' }}>
                <div style={{
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    clip:  'rect(0px, 40px, 40px, 20px)',
                    backgroundColor: '#1F4CC8',
                    transform: `rotate(${degrees}deg)`,
                    transformOrigin: 'center center'
                }}></div>
                {degrees <= 180 && (
                    <div style={{
                        position: 'absolute',
                        width: '100%',
                        height: '100%',
                        clip: 'rect(0px, 20px, 40px, 0px)',
                        backgroundColor: '#1F4CC8',
                        transform: 'rotate(360deg)',
                        transformOrigin: 'center center'
                    }}></div>
                )}

                {degrees > 180 && (
                    <div style={{
                        position: 'absolute',
                        width: '100%',
                        height: '100%',
                        clip: 'rect(0px, 20px, 40px, 0px)',
                        backgroundColor: 'white',
                        transform: 'rotate(180deg)',
                        transformOrigin: 'center center'
                    }}></div>
                )}
                
            </div> */}
        </div>
    );
}